import { render, staticRenderFns } from "./ElementsCopy.vue?vue&type=template&id=02ad5716&"
import script from "./ElementsCopy.vue?vue&type=script&lang=js&"
export * from "./ElementsCopy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports